/**
 * Brands and Products form logic.
 *
 * Views: advertisers/partials/brand-product-inputs
 */

$(document).ready(function() {
   var arr = window.location.href.split('?');
    if(arr.length > 1){
        if(arr[1] == 'new') {
            $('.check_default').attr('checked', 'checked');
            $('.default_contact').val('1');
        }
    }

    /*$(window).keydown(function(event){
        if(event.keyCode == 13 || event.keyCode == 9) {
            event.preventDefault();
            return false;
        }
    });*/

    $('.taggle').on('mouseover', function(){
        $(this).find('.close').each(function(index, value){
            $(value).attr('style', 'display: block');
        });
    });

    $(".product-container").on('click', function(){
        $(this).attr('style', '');
    });

    var edit = $("#edit_adv").val();
    if(edit > 0){
        var x = 1;
        $(document).find('.taggle_list').each(function (index, value) {
            $(value).find('input').each(function (index1, value1) {
                $(value1).attr('name', 'advertiser_product_' + x + '[]');
                $(value1).attr('data-brand-name', 'advertiser_brand_' + x);
            })
            x++;
        });
        x=1;
        form.find('.brand').each(function (index, value) {
            $(value).attr('name', 'advertiser_brand_' + x);
            brand_prod_name[$(value).attr('name')]= $(value).attr('data-brand-id');
            x++;
        });
        console.log('brand_prod_name', brand_prod_name);
        $(document).find('.taggle_input').each(function(index, value){
            $(value).attr('name', 'taggle_input');
        });
    }
});

if ($('#brands-products-form').length) {
    var products_taggles = []
    form = $('#brands-products-form');

    document.getElementById('est_budget').addEventListener('input', function (e) {
        const value = e.target.value;
        if (!/^-?\d*(\.\d*)?$/.test(value)) {
            e.target.value = value.slice(0, -1); // remove last invalid character
        }
    });

    $('#btn-submit-adv-update').on('click', function (e) {
         if(editing_adv == 0) {
             $('#array_brand_hidden').val(brand_prod_name);

             var bo = false;
             $(document).find('.error_msg').each(function(index, value){
                 bo = true;
             });
             if(bo)
                 e.preventDefault();
             else
                 $('#brands-products-form').submit();
         }
     else {
         console.log('brand_prod_name sendind', brand_prod_name);
         var params = {
             advertiser_name: $('#advertiser_name').val(),
             buyer_agencies_input: $('#buyer_agencies_input option:selected').val(),
             assigned_to: $('#assigned_to option:selected').val(),
             advertiser_agency_commission: $('#advertiser_agency_commission').val(),
             advertiser_comments: $('#advertiser_comments').val(),
             adv_tv_commission: $('#adv_tv_commission').val(),
             adv_radio_commission: $('#adv_radio_commission').val(),
             adv_digital_commission: $('#adv_digital_commission').val(),
             adv_print_commission: $('#adv_print_commission').val(),
             adv_mail_commission: $('#adv_mail_commission').val(),
             adv_ooh_commission: $('#adv_ooh_commission').val(),
             adv_other_commission: $('#adv_other_commission').val(),
             adv_ott_commission: $('#adv_ott_commission').val(),
             adv_podcast_commission: $('#adv_podcast_commission').val(),
             brand_deleted: [],
             brand_edit: [],
             prod_edit: [],
             brand_new: [],
             prod_edit_count: [],
             edited: [],
             prod_new: [],
             prod_new_count: [],
             advertiser_id: adv_id,
             users_access: $('#users_access').val(),
             bookend_rule: $('#bookend_rule option:selected').val(),
             adv_category: $('#adv_category option:selected').val(),
             adv_subcategory: $('#adv_subcategory option:selected').val(),
             est_budget: $('#est_budget').val(),
             adv_website: $('#adv_website').val(),
             adv_exp_start: $('#adv_exp_start').val(),
             adv_exp_end: $('#adv_exp_end').val(),
             adv_keywords: $('#adv_keywords').val(),
             adv_prod_category: $('#adv_prod_category option:selected').val(),
             adv_prod_subcategory: $('#adv_prod_subcategory option:selected').val(),
             adv_cadence: $('#adv_cadence option:selected').val(),
             adv_forecast: $('#adv_forecast').val(),
             adv_lead_source: $('#adv_lead_source option:selected').val(),
             adv_next_action: $('#adv_next_action').val(),
             adv_ownership: $('#adv_ownership option:selected').val(),
             adv_advertisers: $('#adv_advertisers').val(),
         };
         var deleted = [];
         var cont = 1;
         var deleted_arr = [];

         $('.brand-product-row').each(function () {
             if ($(this).css('display') == 'none')
                 deleted.push(cont);
             cont++;
         });
         cont = 1;
         $('.brand-product-row .brand_class').each(function () {
             if (deleted.indexOf(cont) !== -1) {
                 deleted_arr.push($(this).attr('name'));
             }
             cont++;
             console.log('this', $(this).html());
             console.log('display', $(this).css('display'));
             console.log('name', $(this).attr('name'));

         });
   console.log('deleted_arr', deleted_arr);
         for (var name in brand_prod_name) {
             if (deleted_arr.indexOf(name) == -1) {
                 if (brand_prod_name[name] > 0) {
                     var string = name.toString().split('_');
                     var xx = string[2];
                     var name_xx = name;
                     var brand_val = $("input[name=" + name_xx + "]").val();

                     params.brand_edit.push(brand_val);
                     params.edited.push(brand_prod_name[name]);
                     var x = 0;
                     $("#products_" + xx + " input").each(function () {
                         if ($(this).attr('data-brand-name') == name_xx && $(this).val() != "") {
                             if ($(this).attr('data-brand-name') == name_xx) {
                                 params.prod_edit.push($(this).val());
                                 x++;
                             }
                         }
                     });
                     params.prod_edit_count.push(x);
                 } else {
                     var string = name.toString().split('_');
                     var xx = string[2];

                     var name_xx = name;
                     var brand_val = $("input[name=" + name_xx + "]").val();
                     if (brand_val != "") {
                         if ($("#" + name + "").val() !== "") {
                             params.brand_new.push(brand_val);
                             var x = 0;
                             $("#products_" + xx + " input").each(function () {
                                 if ($(this).attr('data-brand-name') == name_xx && $(this).val() != "") {
                                     params.prod_new.push($(this).val());
                                     x++;
                                 }
                             });
                             params.prod_new_count.push(x);
                         }
                     }
                 }
             }
             else if(brand_prod_name[name] > 0)
                 params.brand_deleted.push(brand_prod_name[name]);
         }

         console.log('params', params);
         console.log('JSON.stringify(params)', JSON.stringify(params));

         $.ajax({
             type: 'POST',
             headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
             url: '/advertisers/update/new',
             data: JSON.stringify(params),
             contentType: "application/json",
             dataType: 'json',
             encode: true,
             success: function (data) {
                 global_notification('success', 'Advertiser Updated...')
                // location.reload();
                 window.location.href = data.redirect;
             },
             error: function (xhr) {
                 hide_loader();
                 ajax_error();
                 debug(xhr.responseText);
             }
         });
     }

    });
    $('#btn-submit-adv-accounting-update').on('click', function (e) {
        var params = {
             advertiser_id: adv_id,
             advertiser_code: $('#advertiser_code').val(),
             advertiser_sales_class_adv: $('#advertiser_sales_class_adv').val(),
             min_before_program: $('#min_before_program').val(),
             min_after_program: $('#min_after_program').val(),
             client_rate_commission: $('#client_rate_commission').val(),
             client_rate: $('input:radio[name=client_rate]:checked').val(),
             broadcast_only: $("#broadcast_only").is(':checked') ? 1: 0,
         };

        $.ajax({
             type: 'POST',
             headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
             url: '/advertisers/update/accounting',
             data: JSON.stringify(params),
             contentType: "application/json",
             dataType: 'json',
             encode: true,
             success: function (data) {
                 global_notification('success', 'Advertiser Accounting Updated...')
                 location.reload();
             },
             error: function (xhr) {
                 hide_loader();
                 ajax_error();
                 debug(xhr.responseText);
             }
         });

    });


    // form.find('submit').unbind('click').bind('click', function (e) {
    //     $('#array_brand_hidden').val(brand_prod_name);
    //     alert($('#array_brand_hidden').val());
    //     console.log('$(#array_brand_hidden).val', $('#array_brand_hidden').val())
    //     var bo = false;
    //     $(document).find('.error_msg').each(function(index, value){
    //         bo = true;
    //     });
    //     if(bo)
    //         e.preventDefault();
    // });

    var init_products = function() {
        var edit = $("#edit_adv").val();
        if(edit > 0){
            var con1 = 1;
            form.find('.product-container').each(function (index, value) {
                if (con1 <= edit){
                    $(value).html('<div id="products_' + con1 + '" class="form-control select2 full-width product input textarea"></div>');
                    con1++;
                }
            });
            con1 = 0;
            var fill = [];
            form.find('.fill_products').each(function (index, value) {
                fill.push($(value).val());
                con1++;
            });
            form.find('.select2').each(function(index1, value1){
                if(index1 <= con1){
                    var arr = fill[index1].split(',');
                    arr.pop();
                    products_taggles.push(new Taggle($(value1).attr('id'), {
                        tags: arr,
                        placeholder: 'Enter the product...',
                        preserveCase: true
                    }));
                }
            });

            var x = 1;
            form.find('.taggle_list').each(function (index, value) {
                $(value).find('input').each(function (index1, value1) {
                    $(value1).attr('name', 'advertiser_product_' + x + '[]');
                    $(value1).attr('data-brand-name', 'advertiser_brand_' + x);
                })
                x++;
            });
            form.find('.taggle_input').each(function(index, value){
                $(value).attr('name', 'taggle_input');
            });
        }
    }

    var edit = $("#edit_adv").val();
    if(edit > 0){
        var con1 = 1;
        form.find('.product-container').each(function (index, value) {
            if (con1 <= edit){
                $(value).html('<div id="products_' + con1 + '" class="form-control select2 full-width product input textarea"></div>');
                con1++;
            }
        });
        con1 = 0;
        var fill = [];
        form.find('.fill_products').each(function (index, value) {
            fill.push($(value).val());
            con1++;
        });
        form.find('.select2').each(function(index1, value1){
            if(index1 <= con1){
                var arr = fill[index1].split(',');
                arr.pop();
                products_taggles.push(new Taggle($(value1).attr('id'), {
                    tags: arr,
                    placeholder: 'Enter the product...',
                    preserveCase: true
                }));
            }
        });

        var x = 1;
        form.find('.taggle_list').each(function (index, value) {
            $(value).find('input').each(function (index1, value1) {
                $(value1).attr('name', 'advertiser_product_' + x + '[]');
            })
            x++;
        });
        form.find('.taggle_input').each(function(index, value){
            $(value).attr('name', 'taggle_input');
        });
    }

    var con = 1;
    var brand_product_bind = function () {
        form = $('#brands-products-form');
        form.find('.brand-continue').unbind('click').bind('click', function () {
            var inp = $($(this).parents()[0]).find('input')[0];
            if($(inp).val() != "") {
                brand_product_continue1(inp);
                var x = 1;
                form.find('.brand').each(function (index, value) {
                    $(value).attr('name', 'advertiser_brand_' + x);
                    brand_prod_name[$(value).attr('name')]= $(value).attr('data-brand-id');
                    x++;
                });
            }
        });
        console.log('second brand_prod_name', brand_prod_name);

        form.find('.brand').unbind('keyup').bind('keyup', function (e) {
            if(e.keyCode == 13 || e.keyCode== 9){
                if($(this).val() != '') {
                    brand_product_continue1(this);
                    var x = 1;
                    form.find('.brand').each(function (index, value) {
                        $(value).attr('name', 'advertiser_brand_' + x);
                        brand_prod_name[$(value).attr('name')]= $(value).attr('data-brand-id');
                        x++;
                    });
                }
            }
        });
        console.log('third brand_prod_name', brand_prod_name);

        form.find('.taggle_input').unbind('keyup').bind('keyup', function (e) {
            if(e.keyCode == 13 || e.keyCode== 9) {
                var x = 1;
                form.find('.taggle_list').each(function (index, value) {
                    $(value).find('input').each(function (index1, value1) {
                        $(value1).attr('name', 'advertiser_product_' + x + '[]');
                        $(value1).attr('data-brand-name', 'advertiser_brand_' + x);
                    })
                    x++;
                });
                form.find('.taggle_input').each(function(index, value){
                    $(value).attr('name', 'taggle_input');
                });
            }
        });

        form.find('.taggle_input').unbind('focusout').bind('focusout', function (e) {
            console.log("ENTERING FOCUSOUT: ", $(this).val())
            if($(this).val() !== "") {
                console.log($(this).closest(".select2").attr("id"), $(this).closest(".select2").attr("id").split('_')[1], products_taggles)
                products_taggles[$(this).closest(".select2").attr("id").split('_')[1] - 1].add($(this).val());

                var x = 1;
                form.find('.taggle_list').each(function (index, value) {
                    $(value).find('input').each(function (index1, value1) {
                        $(value1).attr('name', 'advertiser_product_' + x + '[]');
                        $(value1).attr('data-brand-name', 'advertiser_brand_' + x);
                    })
                    x++;
                });
                form.find('.taggle_input').each(function(index, value){
                    $(value).attr('name', 'taggle_input');
                });
            }
        });

        form.find('.row-remove').unbind('click').bind('click', function () {
            console.log('prod remove');
            bo = false;
            $(document).find('.error_msg').each(function(index, value){
                bo = true;
            });
            if(typeof ordered_brands !== 'undefined' && ordered_brands.indexOf(parseInt($(this).attr('data-brand-id'))) !== -1) {
                bo = true;
                swal({
                        title: "Warning!",
                        text: "This Brand has been used, you can not delete it.",
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });
            }else if(!bo) {
                brand_product_remove(this);
                $('#btn-submit').removeAttr('disabled');
                $('.wiz-next').hide();
                $('.wizard-next').show();
            }else
                brand_product_remove(this);
        });

        form.find('.brand').unbind('focusout').bind('focusout', function () {
            var v = $(this).val();
            var b = false;
            if(v == '') {
                $($(this).parents()[2]).find('.taggle_list').each(function (index, value) {
                    var tot = 0;
                    $(value).find('li').each(function (index1, value1) {
                        tot++;
                    });
                    if (tot > 1)
                        b = true;
                });
                if(b){
                    //PUT THE ERROR
                    $(this).removeClass('with-errors');
                    $(this).attr('class', $(this).attr('class') + ' with-errors');
                    $(this).attr('aria-invalid', 'true');
                    var bo = false;
                    $($(this).parents()[1]).find('.error_msg').each(function(index, value){
                        bo = true;
                    });
                    if(!bo)
                        $(this).parent().after('<div id="advertiser_brand-error" class="with-errors error_msg">Please provide a Brand name.</div>');
                    $('.wizard-next').hide();
                    bo = false;
                    $(document).find('.wiz-next').each(function(index, value){ bo = true; });
                    if(!bo)
                        $('.wizard-next').parent().after('<a class="btn btn-primary wiz-next" style="float: right;color: white">Next</a>');
                    else
                        $('.wiz-next').show();
                    $('#btn-submit').attr('disabled', 'disabled');
                }
            }else{
                $(this).removeClass('with-errors');
                $(this).attr('aria-invalid', 'false');
                $($(this).parents()[1]).find('.error_msg').each(function(index, value){
                    $(value).remove();
                });
                $('.wizard-next').show();
                $('.wiz-next').hide();
                bo = false;
                $(document).find('.error_msg').each(function(index, value){
                    bo = true;
                });
                if(!bo)
                    $('#btn-submit').removeAttr('disabled');
            }
        });

        form.find('.product-container .taggle_list .close').on('click', function (e) {
            var id = $(this).parent().children('input').attr('data-brand-name').split('advertiser_brand_')[1];
            var parent = $(this).parent().parent().parent().parent();
            var html = $(this).parent().children('span').html().trim();
            if (typeof ordered_products !== 'undefined' && ordered_products.indexOf(html) !== -1) {
                swal({
                        title: "Warning!",
                        text: "This Product has been used, you can not delete it.",
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            init_products();
                            brand_product_bind();
                        }
                    });
            }
        })


        /*form.find('taggle_list.li.input').each(function (index, value) {
            $(value).attr('name', 'advertiser_brand_' + x);
            if ($(value).closest('.brand-product-row').find('div.product').length) {
                $(value).closest('.brand-product-row').find('div.product').attr('name', 'advertiser_product_' + x + '[]')
            }
            x++;
        });*/
    };

    var brand_product_continue = function (el) {
        $(el).removeClass('brand-continue').addClass('row-remove').removeClass('text-success')
            .addClass('text-primary').html('<i class="fa fa-times fa-fw"></i>');

        //$(el).closest('.brand-product-row').find('input.brand').attr('readonly', 'readonly');

        $(el).closest('.brand-product-row').find('.product-container')
            .html('<select class="form-control select2 full-width product" multiple><option></option></select>');

        $(el).closest('.brand-product-row').after('<div class="form-inline row m-b-10 brand-product-row"><div class="col-sm-6 brand-container"><div class="input-group"><input id="brands_group" data-brand-id="0" class="form-control full-width brand ignore brand_class" placeholder="Enter a Brand..." /><span class="input-group-addon text-success brand-continue"><i class="fa fa-arrow-right fa-fw"></i></span></div></div><div class="col-sm-6 product-container"></div></div>');

        brand_product_bind();
    };

    var brand_product_continue1 = function (el) {
        if(edit > 0){
            var n = el.name.split('_')[2];
            //alert(edit+' '+n);
            if(n > edit){
                con = n;
                var sp = $(el.closest('div').getElementsByClassName('brand-continue')[0]);
                sp.removeClass('brand-continue').addClass('row-remove').removeClass('text-success')
                    .addClass('text-primary').html('<i class="fa fa-times fa-fw"></i>');

                //sp.closest('.brand-product-row').find('input.brand').attr('readonly', 'readonly');

                sp.closest('.brand-product-row').find('.product-container')
                    .html('<div id="products_'+ con +'" class="form-control select2 full-width product input textarea"></div>');
                //.html('<select class="form-control select2 full-width product" multiple><option></option></select>');
                products_taggles.push(new Taggle('products_'+con, {
                    placeholder: 'Enter the product...',
                    preserveCase: true
                }));
                con++;

                sp.closest('.brand-product-row').after('<div class="form-inline row m-b-10 brand-product-row"><div class="col-sm-6 brand-container"><div class="input-group"><input id="brands_group" data-brand-id="0" class="form-control full-width brand ignore brand_class" placeholder="Enter a Brand..." /><span class="input-group-addon text-success brand-continue"><i class="fa fa-arrow-right fa-fw"></i></span></div></div><div class="col-sm-6 product-container"></div></div>');

                brand_product_bind();

                var sel = $(el.closest('.brand-product-row').getElementsByClassName('taggle_input')[0]);
                sel.focus();
                edit++;
            }else{
                var sel = $(el.closest('.brand-product-row').getElementsByClassName('taggle_input')[0]);
                if(sel.attr('class') != undefined)
                    sel.focus();
                else{
                    var sp = $(el.closest('div').getElementsByClassName('brand-continue')[0]);
                    sp.removeClass('brand-continue').addClass('row-remove').removeClass('text-success')
                        .addClass('text-primary').html('<i class="fa fa-times fa-fw"></i>');

                    //sp.closest('.brand-product-row').find('input.brand').attr('readonly', 'readonly');

                    sp.closest('.brand-product-row').find('.product-container')
                        .html('<div id="products_'+ con +'" class="form-control select2 full-width product input textarea"></div>');
                    //.html('<select class="form-control select2 full-width product" multiple><option></option></select>');
                    products_taggles.push(new Taggle('products_'+con, {
                        placeholder: 'Enter the product...',
                        preserveCase: true
                    }));
                    con++;

                    sp.closest('.brand-product-row').after('<div class="form-inline row m-b-10 brand-product-row"><div class="col-sm-6 brand-container"><div class="input-group"><input data-brand-id="0" id="brands_group" class="form-control full-width brand ignore brand_class" placeholder="Enter a Brand..." /><span class="input-group-addon text-success brand-continue"><i class="fa fa-arrow-right fa-fw"></i></span></div></div><div class="col-sm-6 product-container"></div></div>');

                    brand_product_bind();

                    var sel = $(el.closest('.brand-product-row').getElementsByClassName('taggle_input')[0]);
                    sel.focus();
                    edit++;
                }
            }
        }else {
            var sel = $(el.closest('.brand-product-row').getElementsByClassName('taggle_input')[0]);
            if (sel.attr('class') != undefined)
                sel.focus();
            else {
                var sp = $(el.closest('div').getElementsByClassName('brand-continue')[0]);
                sp.removeClass('brand-continue').addClass('row-remove').removeClass('text-success')
                    .addClass('text-primary').html('<i class="fa fa-times fa-fw"></i>');

                //sp.closest('.brand-product-row').find('input.brand').attr('readonly', 'readonly');

                sp.closest('.brand-product-row').find('.product-container')
                    .html('<div id="products_' + con + '" class="form-control select2 full-width product input textarea"></div>');
                //.html('<select class="form-control select2 full-width product" multiple><option></option></select>');
                products_taggles.push(new Taggle('products_' + con, {
                    placeholder: 'Enter the product...',
                    preserveCase: true
                }));
                con++;

                sp.closest('.brand-product-row').after('<div class="form-inline row m-b-10 brand-product-row"><div class="col-sm-6 brand-container"><div class="input-group"><input id="brands_group" data-brand-id="0" class="form-control full-width brand ignore brand_class" placeholder="Enter a Brand..." /><span class="input-group-addon text-success brand-continue"><i class="fa fa-arrow-right fa-fw"></i></span></div></div><div class="col-sm-6 product-container"></div></div>');

                brand_product_bind();

                var sel = $(el.closest('.brand-product-row').getElementsByClassName('taggle_input')[0]);
                sel.focus();
            }
        }
    };

    var brand_product_remove = function (el) {
        if(editing_adv > 0)
          $(el).closest('.brand-product-row').hide();
        else
            $(el).closest('.brand-product-row').remove();

        var form = $('#brands-products-form');
        var x = 1;
        form.find('.brand').each(function (index, value) {
            $(value).attr('name', 'advertiser_brand_' + x);
            brand_prod_name[$(value).attr('name')]= $(value).attr('data-brand-id');
            x++;
        });
        x = 1;
        form.find('.taggle_list').each(function (index, value) {
            $(value).find('input').each(function (index1, value1) {
                $(value1).attr('name', 'advertiser_product_' + x + '[]');
                $(value1).attr('data-brand-name', 'advertiser_brand_' + x);
            })
            x++;
        });
         form.find('.taggle_input').each(function(index, value){
             $(value).attr('name', 'taggle_input');
        });
        console.log('for brand_prod_name', brand_prod_name);
    };



    brand_product_bind();

    var reset_brands_products = function () {
        $('#brands-products-form').html('<div class="form-inline row m-b-10 brand-product-row"><div class="col-sm-6 brand-container"><div class="input-group"><input data-brand-id="0" id="brands_group" class="form-control full-width brand ignore" /><span class="input-group-addon text-success brand-continue"><i class="fa fa-arrow-right fa-fw"></i></span></div></div><div class="col-sm-6 product-container"></div></div>');

        brand_product_bind();
    };
}
